import React from 'react';
import { keyframes } from '@mui/material';
import BrandLogo from '@core/components/ui/BrandLogo';

const flicker = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
`;

const pulse = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
`;

interface BrandLoaderProps {
  size?: number;
}

const BrandLoader: React.FC<BrandLoaderProps> = ({ size = 100 }) => {
  return (
    <BrandLogo
      variant="square"
      height={size}
      width={size}
      sx={{
        animation: `${flicker} 2s ease-in-out infinite, ${pulse} 3s ease-in-out infinite`,
        filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.1))',
      }}
    />
  );
};

export default BrandLoader;
